import React from 'react'
import trustVisual from './mobile-app-trust-visual.png'

   const { location: { hostname } } = window
    const heroSrc = hostname == "localhost" ? trustVisual : `https://res.cloudinary.com/l7pafu4a/image/fetch/f_webp/q_60/https://${hostname}/${trustVisual}`
const trustPoints = [
  {
    title: 'Expert Team with Diverse Skillsets',
    text: 'Our mobile app developers in pakistan bring product thinking, UI design, backend engineering, QA, and release experience together for dependable mobile app development services.'
  },
  {
    title: 'Transparent Development Process',
    text: 'You see priorities, sprint progress, risks, and decisions clearly, whether the roadmap is a focused MVP or a larger custom mobile app development program.'
  },
  {
    title: 'User-Centric Design Focus',
    text: 'Every flow is shaped around real users, so mobile app development in pakistan can still meet international usability, accessibility, and conversion expectations.'
  },
  {
    title: 'Quality, Security & Scale',
    text: 'We build with clean architecture, secure integrations, performance testing, and maintainable code across ios app development and android app development.'
  },
  {
    title: 'Flexible Engagement Models',
    text: 'You can hire app developer talent for a specific roadmap, or work with a complete mobile app development agency from discovery through support.'
  },
]

const WhyTrustMobileApps = ({ points = trustPoints, eyebrow = 'WHY TRUST US', heading = 'Why Trust Metatech Official To Build Your Mobile Apps?', intro = 'As a mobile app development company, we connect strategy, design, engineering, and support so founders can move from idea to launch with fewer surprises.' }) => {
  return (
    <section className="why-trust-mobile-section py-5">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-12 col-lg-6 mb-4 mb-lg-0">
            <h2 className="pb-3 h5 app-section-eyebrow">{eyebrow}</h2>
            <h3 className="display-6 fw-bold text-white">{heading}</h3>
            <p className="lead text-white-50">
              {intro}
            </p>
            <div className="why-trust-image-wrap">
              <img src={heroSrc} alt="Mobile app development company visual with app screens and product roadmap" />
            </div>
          </div>
          <div className="col-12 col-lg-6">
            <div className="why-trust-list">
              {points.map((point) => (
                <article className="why-trust-card" key={point.title}>
                  <h4>{point.title}</h4>
                  <p>{point.text}</p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default WhyTrustMobileApps
